import * as Yup from 'yup';

export const formValidationSchema = Yup.object().shape({
  tgl_pengembalian_sisa_petty_cash: Yup.string().required(
    'Pilih Tanggal Pengembalian Sisa Petty Cash'
  ),
});
